import { useState, useEffect } from 'react';
import { Buttons } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { ValidationOptionsType } from './types';

const ValidationOptions = ({ options }: ValidationOptionsType): JSX.Element => {
  const { t } = useTranslation(locizeNS.AUTH);
  const [disabled, setDisabled] = useState(true);
  const [countdown, setCountdown] = useState(20);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (disabled) {
      timer = setInterval(() => {
        setCountdown(prevCount => {
          if (prevCount <= 1) {
            setDisabled(false);
            return 0;
          }
          return prevCount - 1;
        });
      }, 1000);
    }
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [disabled]);

  const handleClick = (id: string, action: () => void): void => {
    if (id === 'sendCodeButton') {
      setDisabled(true);
      setCountdown(20);
      action();
    } else {
      action();
    }
  };
  return (
    <Buttons.Classic
      label={
        t(options[0].label) +
        (disabled && options[0].id === 'sendCodeButton' ? ` (${countdown}s)` : '')
      }
      mode="primary"
      size="m"
      disabled={disabled}
      onClick={() => handleClick(options[0].id, options[0].action)}
    />
  );
};

export default ValidationOptions;
